import { useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { Box, Button } from "@mui/material";
import { formConfig } from "./formConfig";
import Field from "@/components/RHFcomponents/Field";
import { useLoginMutation } from "@/redux-store/api/marketingApi.ts";
import { fetchCheckoutById } from "@/api/fetchCheckoutById";
import Loader from "@/components/Shared/loader";
import Notification from "@/components/Notification/Notification.tsx";

// eslint-disable-next-line react-refresh/only-export-components
export const getCheckoutData = async (id: number) => {
  try {
    const checkoutData = await fetchCheckoutById(id);
    return checkoutData;
  } catch (error) {
    console.error("Error fetching checkout:", error);
    return null;
  }
};

const LoginForm = ({
  goToLoginCheckout,
  setCheckoutData,
}: {
  goToLoginCheckout: () => void;
  setCheckoutData: (data: ICheckoutForm | null) => void;
}) => {
  const { handleSubmit, control } = useForm<ILoginForm>(formConfig);
  const [login] = useLoginMutation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [notificationIsOpen, setNotificationIsOpen] = useState(false);

  const [notification, setNotification] = useState({
    open: false,
    title: "",
    description: "",
  });

  const onSubmit: SubmitHandler<ILoginForm> = async (
    data: ILoginForm,
    event: any
  ) => {
    try {
      event.preventDefault();
      setIsSubmitting(true);
      const hoursOffset = Math.floor(new Date().getTimezoneOffset() / 60);
      const payload = { ...data, idTimeZone: hoursOffset };
      const res = await login(payload).unwrap();
      if (res.active === true) {
        const checkoutData = await getCheckoutData(res.id);
        setCheckoutData(checkoutData);
        goToLoginCheckout();
      }
    } catch (e: unknown) {
      const error = e as { data: string };
      setNotification({
        open: true,
        title: "Error",
        description: error.data,
      });
      setNotificationIsOpen(true);
    } finally {
      setIsSubmitting(false);
      setTimeout(() => {
        setNotificationIsOpen(false);
      }, 2500);
    }
  };

  return (
    <Box
      component="form"
      gap={{ xs: 2, md: 2.5 }}
      display="flex"
      flexDirection="column"
      onSubmit={handleSubmit(onSubmit)}
      mb={{ xs: 3, md: 2 }}
    >
      <Field name="username" control={control} placeholder="Your username" />
      <Field name="password" control={control} placeholder="Password" />
      {isSubmitting ? (
        <Box display="flex" justifyContent="center" mt={2}>
          <Loader />
        </Box>
      ) : (
        <Button variant="contained" type="submit">
          Log in
        </Button>
      )}
      <Notification
        open={notificationIsOpen}
        onClose={() => setNotificationIsOpen(false)}
        title={notification.title}
        description={notification.description}
        severity="error"
      />
    </Box>
  );
};

export default LoginForm;
